import { TextButton2 } from "common/components";
import styled from "styled-components";

export const DataCard = ({ title, children }) => {
  return (
    <DataCardContainer>
      <TextButton2>{title}</TextButton2>
      {children}
    </DataCardContainer>
  );
};

export const DataCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 2rem 1.5rem;
  gap: 1.25rem;
  background-color: #f8f8f8;
  border-radius: 0.5rem;
`;

export const DataCardLabel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 0.5rem;
  box-sizing: border-box;
`;
